
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import CommunityHelperCategoryForm from "../CommunityHelperCategoryForm";
import CommunityHelperForm from "../CommunityHelperForm";

interface CommunityHelperCategory {
  id: string;
  name: string;
  color: string;
  display_order: number;
  is_active: boolean;
}

interface CommunityHelper {
  id: string;
  name: string;
  description: string;
  image_url: string;
  tools: string[];
  uniform: string;
  workplace: string;
  fun_fact: string;
  category_id: string | null;
  display_order: number;
  is_active: boolean;
  community_helper_categories?: { name: string };
}

interface CommunityHelpersDialogsProps {
  categoryDialogOpen: boolean;
  helperDialogOpen: boolean;
  selectedCategory?: CommunityHelperCategory;
  selectedHelper?: CommunityHelper;
  isSubmitting: boolean;
  onCategoryDialogClose: () => void;
  onHelperDialogClose: () => void;
  onCategorySubmit: (data: Omit<CommunityHelperCategory, 'id'>) => Promise<void>;
  onHelperSuccess: () => void;
  onCancel: () => void;
}

const CommunityHelpersDialogs = ({
  categoryDialogOpen,
  helperDialogOpen,
  selectedCategory,
  selectedHelper,
  isSubmitting,
  onCategoryDialogClose,
  onHelperDialogClose,
  onCategorySubmit,
  onHelperSuccess,
  onCancel
}: CommunityHelpersDialogsProps) => {
  return (
    <>
      <Dialog open={categoryDialogOpen} onOpenChange={onCategoryDialogClose}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {selectedCategory ? "Edit Category" : "Create Category"}
            </DialogTitle>
          </DialogHeader>
          <CommunityHelperCategoryForm
            category={selectedCategory}
            onSubmit={onCategorySubmit}
            onCancel={onCancel}
            isSubmitting={isSubmitting}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={helperDialogOpen} onOpenChange={onHelperDialogClose}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>
              {selectedHelper ? "Edit Community Helper" : "Create Community Helper"}
            </DialogTitle>
          </DialogHeader>
          <CommunityHelperForm
            helper={selectedHelper}
            onSuccess={onHelperSuccess}
            onCancel={onCancel}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CommunityHelpersDialogs;
